// @flow

/* eslint-disable import/prefer-default-export */
import { Router } from '@i18n';

import type { Response, Route } from './types';

export const redirectServer = (route: Route, res: Response): void => {
  res.writeHead(302, {
    // Needs to get language subpath within route explicitly,
    // because i18n doesn't take over here
    Location: route
  });
  res.end();
};

export const redirectClient = (route: Route): void => Router.push(route);
